// import { Cart } from '@commerce-cart-webcomponents/sdk';
import { AllocationOption, ServiceLocation } from '@commerce-fulfillment-webcomponents/sdk';
import {
  CheckoutResponse,
  PaymentMethodRequest,
  ErrorResponse,
  FulfillmentRequest,
  CheckoutProfile,
  CreateCheckoutRequest,
  OpeningSchedule,
  TaxDocument,
  TaxDocumentResponse,
  UpdateCheckoutRequest,
  SearchAmwayPeriodRequest,
  UpdateAmwayPeriodRequest,
  PaginatedResponse,
  AmwayPeriodResponse,
} from '../services/models';
import { CheckoutStep } from './enums/checkoutEnums';

export interface IkeyString {
  [key: string]: string;
}

export interface ICheckoutAnyType {
  [key: string]: any;
}

export interface IkeyStringWithKeyStringObject {
  [key: string]: IkeyString;
}

export interface ICmsfulfillmentTypes {
  [key: string]: string | object;
  image: {
    url: string;
  };
}

export interface ICheckoutTncResponse {
  title: string;
  description: string;
  ordertype: string;
  accounttype: string;
}

export interface ICheckoutCmsResponse extends cmsResponse {
  terms_conditions: Array<ICheckoutTncResponse>;
}
export interface ICmsCheckoutTypes {
  tnc: Array<ICheckoutTncResponse>;
}

export interface ILoadingFields {
  isLoading: boolean;
  hasError: boolean;
  error?: unknown;
}

export interface ILoadingObject {
  [key: string]: ILoadingFields;
}
export interface ICheckoutPickupStoresMap {
  [key: string]: ICheckoutPickupStoresObject;
}

export interface ICheckoutPickupStoresOptions {
  name: string;
  line1?: string;
  addressLine: string;
  openTimingsWeekDay?: string;
  openTimingsWeekend?: string;
  id: string;
  contact: string;
  allItemsAvailable?: boolean;
  schedule: OpeningSchedule;
  serviceLocation?: ServiceLocation;
  lat?: number;
  lng?: number;
}
export interface ICheckoutPickupStoresObject {
  isSelected: boolean;
  storeIcon?: string;
  storeName: string;
  lastEvaluatedKey?: string;
  storeList: Array<ICheckoutPickupStoresOptions>;
}

export interface ICheckoutPickupStoresForParamSearch {
  [key: string]: Array<ICheckoutPickupStoresOptions>;
}

export interface shippingTypeAvaialability {
  isExist: boolean;
  isRestricted: boolean;
}
export interface IFulfillmentTypesAndStoreMap {
  delivery: shippingTypeAvaialability;
  pickUp: { [key: string]: shippingTypeAvaialability };
  storeMap: ICheckoutPickupStoresMap;
  pincode: string;
  needToDisabledLocationHeader: boolean;
}

export type InitialCheckoutState = {
  checkout?: CheckoutResponse | null;
  cart: ICheckoutAnyType | null;
  isLoading: boolean;
  hasError: boolean;
  disabledPlaceOrder: boolean;
  placeOrderEnablerStack: Array<boolean>;
  error: unknown;
  currentStep: CheckoutStep;
  pickupDrawerVisibility: boolean;
  pickupContactDrawerVisibility: boolean;
  deliveryOptionsVisibility: boolean;
  notificationPopupVisibility: boolean;
  eventsModalVisibility: boolean;
  loadingState?: ILoadingObject;
  fulfillmentCmsContent?: IkeyStringWithKeyStringObject;
  cmsContent?: ICmsCheckoutTypes;
  fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap;
  deliveryOptionsContainerState: string | undefined;
  shippingDetailsContainerState: string | undefined;
  taxContactContainerState: string | undefined;
  taxDocuments?: Array<TaxDocument>;
  emailRegex?: RegExp;
};

export type CheckoutPublishEventType = {
  event: string;
  payload: CheckoutEventPayloadType;
};

export const checkoutFulfillmentOptions = {
  HOMEDELIVERY: 'homedelivery',
  BOPIS: 'bopis',
  EASYDELIVERYPOINT: 'easyDeliveryPoint',
  DIGITAL: 'digital',
};

export type CheckoutEventPayloadType = {
  checkoutId: string;
  [key: string]: string;
};

export type CheckoutSubscribeEventType = {
  topics: string | string[];
  version: string;
  cb: (a: unknown, b: unknown) => void;
};

export interface CheckoutIdReqPayloadType {
  checkoutId?: string;
}

export interface PincodeReqPayloadType {
  pincode: string;
}

export interface isPaginationType {
  pagination?: boolean;
}

export interface FulfillmentIdReqPayloadType {
  fulfillmentId?: string;
}

export interface OrderIdReqPayloadType {
  orderId: string;
}

export interface CheckoutVersionPayloadType {
  version?: number;
}
export type GetCheckoutProps = CheckoutIdReqPayloadType;
export interface PlaceOrderPayload extends CheckoutIdReqPayloadType, CheckoutVersionPayloadType {}
export type GetCheckoutByOrderIdProps = OrderIdReqPayloadType;
export type GetTaxDocumentsProps = CheckoutIdReqPayloadType;

export interface createCheckoutProps {
  payload: CreateCheckoutRequest;
}

export interface updateCheckoutProps {
  payload: UpdateCheckoutRequest;
}
export interface PlaceOrderProps {
  payload: PlaceOrderPayload;
}

export interface CreatePaymentProps {
  payload: PaymentMethodRequest;
}
export interface UpdatePaymentProps {
  payload: PaymentMethodRequest;
  paymentId: string;
}
export interface confirmDeliveryOptionProps {
  payload: FulfillmentRequest;
}

export interface updateDeliveryOptionProps {
  payload: FulfillmentRequest;
}
export interface getCheckoutProps extends CheckoutIdReqPayloadType {
  payload: PaymentMethodRequest;
}

export type paginationQueryParams = {
  page: string;
  size: string;
};
export interface searchAmwayPeriodProps {
  payload: SearchAmwayPeriodRequest;
  params: paginationQueryParams;
}

export interface updateAmwayPeriodProps {
  payload: UpdateAmwayPeriodRequest;
}

export type CheckoutApiResponse = CheckoutResponse | ErrorResponse;
export type AlocationOptionResponse = Array<AllocationOption> | ErrorResponse;
export type CheckoutProfileResponse = CheckoutProfile | ErrorResponse;
export type CheckoutTaxResponse = TaxDocumentResponse | ErrorResponse;
export type SearchAmwayPeriodApiResponse = PaginatedResponse | ErrorResponse;
export type AmwayPeriodApiResponse = AmwayPeriodResponse | ErrorResponse;

export interface cmsResponse {
  _version: number;
  locale: string;
  uid: string;
  ACL: {};
  _in_progress: boolean;
  created_at: string;
  created_by: string;
  tags: string[];
  title: string;
  updated_at: string;
  updated_by: string;
  publish_details: {
    environment: string;
    locale: string;
    time: string;
    user: string;
  };
}
export interface IFulfillmentCmsResponse extends cmsResponse {
  types: Array<ICmsfulfillmentTypes>;
}

export interface IpropServiceLocationAddress {
  address?: {
    long?: string;
  };
}

export interface CustomRequestOptions {
  headers?: {
    [key: string]: string;
  };
  baseURL?: string;
  version?: string;
  deliverytype?: string;
}
